module.exports = __webpack_public_path__ + "img/icontype2.45c888e0.png";